<template>
  <div 
    class="wonderland"
    ref="wonderlandRef"
  >

    <div class="wonderland__container">
      <span class="wonderland__headline" v-html="headline"></span>
      <span class="wonderland__text" v-html="text"></span>
    </div>

    <div 
      class="wonderland__column wonderland__column--1"
    >
      <div 
        v-for="(image, index) in props.left" 
        :key="index" 
        :class="[
          'wonderland__image-container', 
          index % 2 === 0 ? 'wonderland__image--l' : '',
        ]"
      >
        <img 
          :src="image.image.url" 
          :width="image.image.width"
          :height="image.image.height"
          alt=""
          class="wonderland__image"
        >
      </div>
    </div>

    <div 
      class="wonderland__column wonderland__column--2"
    >
    <div 
        v-for="(image, index) in props.right" 
        :key="index" 
        :class="[
          'wonderland__image-container', 
          index % 2 === 0 ? 'wonderland__image--l' : '',
        ]"
      >
        <img 
          :src="image.image.url" 
          :width="image.image.width"
          :height="image.image.height"
          alt=""
          class="wonderland__image"
        >
      </div>
    </div>
    
    
  </div>
</template>

<script setup>
  import { defineProps, ref, onMounted, onUnmounted } from 'vue';

  const props = defineProps({
    left: Array,
    right: Array,
    headline: String,
    text: String,
  });

  const observers = ref([]);
  const wonderlandRef = ref(null);
  const lastScrollTop = ref(0);
  let scrollTop = ref(0);
  let isScrollingDown = ref(true);

  const handleScroll = () => {
    scrollTop = wonderlandRef.value.scrollTop;
    console.log(scrollTop);
    
    if (scrollTop > lastScrollTop.value) {
      // console.log('Scrolling down');
      isScrollingDown.value = true;
    } else if (scrollTop < lastScrollTop.value) {
      // console.log('Scrolling up');
      isScrollingDown.value = false;
    } 
    lastScrollTop.value = scrollTop;
  };

  onMounted(() => {
    wonderlandRef.value.scrollTo({ top: window.innerHeight * 0.5 });
    wonderlandRef.value.addEventListener('scroll', handleScroll);
  });

  onMounted(() => {
    const options = {
      root: null,
      rootMargin: '50%',
      threshold: .1
    };

    const handleIntersection = (index) => (entries) => {
      entries.forEach((entry, entryIndex) => {
        if (entry.isIntersecting && isScrollingDown.value) {
          // Scrolling down
          entry.target.classList.remove('image--scrolled-up');
          entry.target.classList.add('image--scrolled-down');
        }
        else if (entry.isIntersecting && !isScrollingDown.value) {
          // Scrolling up
          entry.target.classList.add('image--scrolled-up');
          entry.target.classList.remove('image--scrolled-down');
        }       
      });
    };

    const images = document.querySelectorAll('.wonderland__image-container');
    images.forEach((image, index) => {
      const observer = new IntersectionObserver(handleIntersection(index), options);
      observers.value.push(observer);
      observer.observe(image);
    });
  });

</script>